export const linkOverrides = {
  root: {
    fontSize: '14px',
    textDecoration: 'none',
  },
};
